<template>

  <!-- Illustration Gallery Content -->
  <div
    class="illustration-gallery-content"
    :class="{'is-fullscreen': isFullscreen}">

    <q-responsive
      :ratio="ratio"
      :style="{minHeight}">

      <q-carousel
        animated
        swipeable
        navigation
        v-model="carousel"
        :style="{minHeight}"
        transition-next="slide-left"
        transition-prev="slide-right">

        <illustration-gallery-element
          :key="index"
          :name="index"
          :value="element"
          v-for="(element, index) in value.elements"/>

        <template
          v-if="value.elements.length > 1"
          v-slot:navigation-icon="{active, btnProps, onClick}">

          <div
            v-if="active"
            @click="onClick"
            class="illustration-gallery-content__nav_active"/>

          <div
            v-else
            @click="onClick"
            class="illustration-gallery-content__nav"/>

        </template>

      </q-carousel>

    </q-responsive>

  </div>

</template>

<script>

  import IllustrationGalleryElement from 'components/element/illustration-gallery-element';

  export default {
    name: 'illustration-gallery-content',
    props: {
      value: {
        type: Object,
        required: true,
      },
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      IllustrationGalleryElement,
    },
    data() {
      return {
        carousel: 0,
      };
    },
    computed: {
      ratio() {

        if (this.onlyMedia)
          return 16 / 9;

        if (this.$q.screen.lt.sm)
          return 10 / 16;

        if (this.$q.screen.lt.md)
          return 1;

        return 16 / 9;
      },
      minHeight() {

        return this.onlyMedia ? 0 : '500px';
      },
      onlyMedia() {

        const slides = this.value
          && this.value.elements
          || [];
        const currentSlide = slides[this.carousel];
        if (!currentSlide) return false;
        const hasTitle = !!this.$u.htmlHasContent(
          this.$u.localize(
            currentSlide.title,
          ),
        );
        const hasBody = !!this.$u.htmlHasContent(
          this.$u.localize(
            currentSlide.body,
          ),
        );
        const hasButtons = !!(
          currentSlide.buttons &&
          currentSlide.buttons.length
        );
        return !(
          hasTitle &&
          hasBody &&
          hasButtons
        );
      },
    },
  };

</script>

<style lang="scss">

  .illustration-gallery-content {
    color: inherit;

    .q-carousel,
    .q-responsive {
      min-height: 500px;
    }

    .q-carousel {
      border-radius: $card-radius;

      @media (min-width: $breakpoint-md) {
        max-height: 100% !important;
      }
    }

    &.is-fullscreen {

      .q-carousel {
        border-radius: 0;
      }

      .q-carousel,
      .q-responsive {
        height: 100vh !important;
        min-height: 100vh !important;
        max-height: 100vh !important;
      }
    }

    .q-panel {
      overflow: hidden;
    }

    &__nav,
    &__nav_active {
      width: 50px;
      height: 10px;
      cursor: pointer;
      border-radius: 2px;
      margin: $spacer-sm $spacer-xs;
    }

    &__nav {
      background-color: $grey-5;
    }

    &__nav_active {
      background-color: $grey-8;
    }

    @media (max-width: $breakpoint-sm) {

      &__nav,
      &__nav_active {
        width: 40px;
      }
    }

    @media (max-width: $breakpoint-xs) {

      &__nav,
      &__nav_active {
        opacity: 0;
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
    }
  }

</style>
